/** 195 -> "3:15" */
export function formatDuration(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** 65.34 -> "1:05.3" - the player clock, where tenths matter when looping. */
export function formatClock(sec: number): string {
  const t = Math.max(0, sec);
  const m = Math.floor(t / 60);
  const s = t - m * 60;
  return `${m}:${s.toFixed(1).padStart(4, '0')}`;
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}

/** "just now", "5 min ago", "3 h ago", "2 days ago", or the UTC date. */
export function timeAgo(iso: string | null): string {
  if (!iso) return 'never';
  const sec = (Date.now() - new Date(iso).getTime()) / 1000;
  if (sec < 60) return 'just now';
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} h ago`;
  if (sec < 14 * 86400) return plural(Math.floor(sec / 86400), 'day') + ' ago';
  return iso.slice(0, 10);
}

/** 2026-09-18T17:51:59Z -> "2026-09-18 17:51 UTC" */
export function utcStamp(iso: string): string {
  return `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC`;
}
